export class XhrSender {
    constructor(options = {}) {
        this.form = options.form;
    }

    async send() {
        return new Promise(((resolve, reject) => {
            if (!this.form
                || !this.form.method
                || !this.form.action) {
                reject();
                return;
            }

            const method = this.form.method;
            const url = this.form.action;
            const formData = new FormData(this.form);
            const xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.send(formData);
            xhr.onload = () => {
                let jsonResponse = null;
                try {
                    jsonResponse = JSON.parse(xhr.response);
                } catch (ex) {
                    console.error('Не удалось распарсить json: ' + ex.message)
                }
                resolve({
                    xhr,
                    jsonResponse,
                });
            };
        }));
    }
}